import { FormControl, ValidationErrors } from '@angular/forms';

export function fourByteStringValidator(formControl: FormControl): ValidationErrors | null {
  const containsFourByteChar = /[\u{10000}-\u{10FFFF}]/u.test(formControl.value);
  return containsFourByteChar ? { fourByteCharacter: true } : null;
}
